import LayoutCounter from "@/components/HomeCharts/LayoutCounter";
import DialGuegeLayout from "@/components/LayoutCharts/DialGuegeLayout";
import Layout3DTank from "@/components/LayoutCharts/Layout3DTank";
import LayoutDynamicBox from "@/components/LayoutCharts/LayoutDynamicBox";
import LayoutLoadSummary from "@/components/LayoutCharts/LayoutLoadSummary";
import LayoutSplitCounter from "@/components/LayoutCharts/LayoutSplitCounter";
import LayoutTextBox from "@/components/LayoutCharts/LayoutTextBox";
import TableChart from "@/components/LayoutCharts/TableChart";
import LayoutAlarmNotification from "@/components/LayoutCharts/LayoutAlarmNotification";
import PropTypes from "prop-types";
import React from "react";
import ReportChartFetch from "./ReportChartFetch";

function ReportPreview({ item }) {
  const preview = {
    // chart fetch
    bar: <ReportChartFetch data={item} type={item.component} />,
    line: <ReportChartFetch data={item} type={item.component} />,
    comboBar: <ReportChartFetch data={item} type={item.component} />,
    pie: <ReportChartFetch data={item} type={item.component} />,

    // dial fetch
    dial: <DialGuegeLayout data={item} type={item.component} />,
    splitCounter: <LayoutSplitCounter data={item} type={item.component} />,
    tank: <Layout3DTank data={item} type={item.component} />,
    dynamicBox: <LayoutDynamicBox data={item} type={item.component} />,
    loadSummary: <LayoutLoadSummary data={item} type={item.component} />,
    // thermometer: <DialFetch data={item} type={item.component} />,
    counter: <LayoutCounter data={item} type={item.component} />,

    // no extra api
    html: <LayoutTextBox data={item} />,
    textBox: <LayoutTextBox data={item} />,
    alarmNotification: <LayoutAlarmNotification data={item} />,

    // other
    table: <TableChart {...{ data: item }} />,
  };
  return (
    <>
      {/* {item?.component} */}
      <>
        {item?.component === "iframe" ? (
          <iframe title="Dashboard" src={item?.iframe} style={{ width: "100%", height: "60vh" }}>
            Iframe does not supported
          </iframe>
        ) : (
          preview[item?.component] || "Not Supported"
        )}
      </>
    </>
  );
}

export default React.memo(ReportPreview);

ReportPreview.propTypes = {
  item: PropTypes.object,
  iframe: PropTypes.string,
};
